// extracted by mini-css-extract-plugin
module.exports = {"checkmark":"checkmark_checkmark__QVZxL","checkmark--active":"checkmark_checkmark--active__HjPpa"};